// Decided 2026-08-23: 2 weeks from delivery, per SPEC.md §9a's "genuinely
// open" threshold question — resolved, no longer a guess.
export const INSTALLATION_LAG_THRESHOLD_DAYS = 14;

export function daysSince(iso: string): number {
  return Math.floor((Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60 * 24));
}

export function isInstallationOverdue(deliveredAt: string, confirmedSerialCount: number): boolean {
  return confirmedSerialCount === 0 && daysSince(deliveredAt) >= INSTALLATION_LAG_THRESHOLD_DAYS;
}
